import type { JSX } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Card as MantineCard } from '@mantine/core';
import CardActions from './CardActions';
import CardChips from './CardChips';
import CardContent from './CardContent';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';
import type { ICardProps } from './types';
import classes from './Card.module.css';

function Card({
  children,
  linkTo,
  className,
  shadow = 'md',
  withBorder = true,
  responsive = false,
  responsiveCompact = false,
  ...props
}: Readonly<ICardProps>): JSX.Element {
  const cardClassName = classNames(className, classes.card, {
    [classes.cardLink]: linkTo,
    [classes.responsive]: responsive,
    [classes.responsiveCardCompact]: responsiveCompact,
  });

  if (linkTo) {
    return (
      <MantineCard
        className={cardClassName}
        padding={0}
        shadow={shadow}
        withBorder={withBorder}
        component={Link}
        to={linkTo}
        {...props}
      >
        {children}
      </MantineCard>
    );
  }

  return (
    <MantineCard
      className={cardClassName}
      padding={0}
      shadow={shadow}
      withBorder={withBorder}
      {...props}
    >
      {children}
    </MantineCard>
  );
}

Card.Chips = CardChips;
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Actions = CardActions;

export default Card;
